export const BROADCAST_CHANNEL_NAME =
  'tik_tok_for_business_reporting_integration_channel';
